import _ from "lodash";
import styles from "./ActionLink.module.scss";
import * as React from "react";
import classnames from "classnames";
import Link from "next/link";

export interface ActionLinkProps {
    /** The content of the link */
    children: string | JSX.Element | (string | JSX.Element)[];
    /** Additional class to add to the element */
    className?: string;
    href?: string;
    to?: string;
    /** _blank to open another tab */
    target?: string;
    /** Style this link as the default action to take */
    primary?: boolean;
    /** Style this link as an alternative action to take */
    secondary?: boolean;
    /** Click handler */
    onClick?: () => void;
    classes?: string[];
}

const primary = styles["action-link--primary"];
const secondary = styles["action-link--secondary"];

export const ActionLink = (props: ActionLinkProps) => {
    const classes = classnames(styles["action-link"], props.className, props.classes, {
        [primary]: props.primary,
        [secondary]: props.secondary,
    });
    const as = props.to || props.href;
    let href = as;
    if (_.startsWith(as, "/dashboard")) {
        href = "/dashboard/[[...all]]";
    } else if (_.startsWith(as, "/gallery")) {
        href = "/dashboard/[id]";
    } else if (_.startsWith(as, "/up")) {
        href = "/up/[token]";
    }

    let onClick = props.onClick;

    if (!onClick) {
        return <Link href={href} as={as} >
            <a href={href} className={classes} target={props.target}>
        {props.children}</a></Link>
    }

    return (
        <a className={classes} onClick={onClick} href={as} target={props.target}>
            {props.children}
        </a>
    );
};

export default ActionLink;
